export default function ErrorFallBack({ error, resetErrorFunction }) {
	return <div><div>En feil har oppstått</div>
		{resetErrorFunction&&<button onClick={resetErrorFunction}>Prøv om igjen</button>}
		<div>Feilmelding: </div>
		<div>{error&&error}</div>
	</div>
}